import React from "react"
import PropTypes from "prop-types"
import {
  Box,
  TextSM,
  Text,
  Flex,
  Flag,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Stack,
} from "datastory-shared/ui"
import { format } from "datastory-shared/utils/date"
import { niceNum } from "datastory-shared/utils/number"

import { AddToCalendar } from "../AddToCalendar"

export const Item = ({ card }) => {
  return (
    <AccordionItem
      border={0}
      key={card.id}
      mb={["lg", null, "md"]}
      ml={["md", null, "8rem"]}
    >
      {() => (
        <Box border="1px solid" borderColor="gray.100" borderRadius="8px">
          <AccordionButton
            py={["sm", "md", "md"]}
            _expanded={{
              borderBottom: "1px solid",
              borderColor: "gray.100",
            }}
          >
            <Flex w="100%">
              <Flex
                justifyContent="center"
                alignItems="center"
                borderRadius="100%"
                overflow="hidden"
                flex={["0 0 3rem", "0 0 4rem"]}
                height={["3rem", "4rem"]}
                position="relative"
              >
                <Flag
                  variant="circle"
                  name={card.country.iso2}
                  size={[48, 64]}
                />
              </Flex>
              <Flex alignItems="center" pl="md" textAlign={["left", "center"]}>
                <Text>{card.name}</Text>
              </Flex>
            </Flex>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel p="0">
            <Flex
              justifyContent="space-between"
              mb={[null, null, "sm"]}
              ml="sm"
              p={["xs", "sm", "sm"]}
              mr={[null, null, "xl"]}
              display={["block", "block", "flex"]}
            >
              <Stack spacing={[null, null, "xs"]}>
                <TextSM>
                  <strong>Country</strong> {card.country.name}
                </TextSM>
                {/* <TextSM>Will be added in Election Tracker 2.0</TextSM> */}
                <TextSM>
                  <strong>Population</strong>{" "}
                  {niceNum(card.country.population.og_value)}
                </TextSM>{" "}
                {card.country.democracyIndex?.og_value && (
                  <TextSM>
                    <strong>Economist Democracy Index</strong>{" "}
                    {niceNum(card.country.democracyIndex.og_value)} / 10
                  </TextSM>
                )}
                <TextSM>
                  <strong>Election type</strong>{" "}
                  {card.instance_of[0].entity_by_object.name[0].value}
                </TextSM>
                {/* <TextSM>
                  <strong>Electing:</strong> Will be added in Election Tracker
                  2.0
                </TextSM> */}
              </Stack>
              <Stack mb={["sm", 0]} spacing="sm">
                <TextSM>
                  <strong>Election Date</strong>{" "}
                  {format(
                    new Date(card.date),
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    },
                    "en"
                  )}
                </TextSM>
                <Box maxWidth="fit-content">
                  <AddToCalendar name={card.name} date={card.date} />
                </Box>
              </Stack>
            </Flex>
          </AccordionPanel>
        </Box>
      )}
    </AccordionItem>
  )
}

Item.propTypes = {
  card: PropTypes.object,
}
